import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconExcellence = ({
  title = "Excellence",
  color = "orange",
  viewBoxWidth = 40,
  viewBoxHeight = 40,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, color, ...otherProps }}>
    <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <circle fill={uiColorToBaseColor(color)} cx="20" cy="20" r="20" />
        <path
          d="M20 26l-4.662 2.451a1.333 1.333 0 01-1.935-1.406l.89-5.19-3.771-3.677a1.333 1.333 0 01.739-2.275l5.212-.757 2.331-4.723a1.333 1.333 0 012.392 0l2.33 4.723 5.213.757a1.333 1.333 0 01.74 2.275l-3.773 3.676.89 5.191a1.333 1.333 0 01-1.934 1.406L20 26z"
          fill="#FFF"
        />
      </g>
    </svg>
  </Svg.Icon>
)

export default IconExcellence
